import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import useLoader from "src/hooks/useLoader";
import { rejectInterview } from "src/network/interview";
import { JobInterview } from "src/types";

interface IRejectModal {
  interview: JobInterview;
  onReject: (i: JobInterview) => void;
  open: boolean;
  setOpen: (b: boolean) => void;
}

const RejectModal = ({ interview, open, setOpen, onReject }: IRejectModal) => {
  const { id } = interview;
  const reject = async () => {
    const intv = await rejectInterview(id);
    await onReject(intv);
    setOpen(false);
  };
  const { ldng: _reject, loading: _rejecting } = useLoader(reject, {
    errorMsg: "Error rejecting candidate",
    successMsg: "Candidate was rejected"
  });
  return (
    <Modal open={open} onChange={setOpen} className="!w-[500px] text-center">
      <p className="font-poppins text-lg font-semibold mt-6">
        Are you sure about rejecting this candidate?
      </p>

      <p className="mt-6 text-base font-medium text-inactive-gray">
        Once Rejected, Candidates will not be considered for this role again in the future.
      </p>
      <div className="flex items-center justify-center w-full mt-6 gap-6">
        <Button
          className="!w-fit !px-6 !h-[56px] !py-4 !rounded-3xl"
          onClick={() => setOpen(false)}
          variant="white_gray"
        >
          Cancel
        </Button>
        <Button
          className="!w-fit !px-6 !h-[56px]  !py-4 !rounded-3xl"
          onClick={_reject}
          loading={_rejecting}
          variant="red"
        >
          Reject Candidate
        </Button>
      </div>
    </Modal>
  );
};

export default RejectModal;
